import { store } from '../index';
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Grid,
  makeStyles,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import AccountCircleTwoToneIcon from "@mui/icons-material/AccountCircleTwoTone";
import RestaurantMenuTwoToneIcon from "@mui/icons-material/RestaurantMenuTwoTone";

import useMediaQuery from '@mui/material/useMediaQuery';
import useIsDesktop from '../hooks/useIsDesktop';
import IconButton from '@mui/material/IconButton';
import MenuIcon from "@mui/icons-material/Menu";

import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import HomeIcon from "@mui/icons-material/Home";
import { APP_BAR_COLOR, TOKEN_KEY, BUTTON_COLOR } from "../utils/constant";
import LeaveCartPopup from "./LeaveCartPopup";
import SignInPopup from "../screens/login/SignInPopup";
import VectorIcon from "../assets/img/new/Vector.svg";
import CyntraLogo from "../assets/images/cyntra_logo.svg";
import {
  item_list,
  item_category,
  label_list,
  addon_list,
  item_verriant_list,
  store_offers,
  customer_membership,
  set_customer,
  clear_customer,
  set_last_order,
  clearStateData,
  set_order_type,
  preload_menu_data,
} from "../store/actions/action";
import {
  get_item_list,
  get_category,
  get_addon_list,
  get_label_list,
} from "../utils/item_helper";
import { store_offer } from "../utils/store_helper";
import { get_customer_membership_plan } from "../utils/customer_helper";

import { clearCart } from "../store/actions/cartActions";
import { get_order_type } from "../utils/order_helper";

import { useActiveStoreCatalog } from '../store/selectors/menu';
const useStyles = makeStyles(() => ({
  menu_text: {
    marginLeft: "1rem",
    fontSize: "1.2rem !important",
    fontFamily: "'GeorgiaItalic' !important;",
  },
}));

const Navbar = function (props) {
  const { reducer, cartProps } = props;
  const { customer } = reducer;
  const orderType = props.cartProps?.orderType;
  const { items: catalogItems, categories: catalogCategories, addons: catalogAddons } = useActiveStoreCatalog();
  const storeInfo = props.sessionReducer?.store_details;

  const storeInfoConfig = props.sessionReducer?.store_config;

  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;
  const menuStore = storeInfoConfig?.web_ordering_setting?.is_menu === true;
  const filter = JSON.parse(localStorage.getItem("filter"));
  const isFSR = props.sessionReducer?.is_fsr === true;

  const { addedItems } = cartProps;
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [skipSignin, setSkipSignin] = useState(false);
  const [openLeaveCartPopup, setOpenLeaveCartPopup] = useState(false);

  const handleHomeClick = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const isCartPage = props.cartPage || location.pathname === "/cart" || location.pathname === "/checkout";
    const hasCartItems = addedItems && addedItems.length > 0;
    if (isCartPage && hasCartItems) {
      setOpenLeaveCartPopup(true);
    } else {
      navigate("/", { state: { skipAutoRedirect: true } });
    }
  };

  const isDesktop = useIsDesktop();

  let type = orderType?.order?.order_code;
  let Ordertype = orderType?.order?.order_type;
  const [newOrderType, setNewOrderType] = useState(type);

  let user = store.getState().sessionReducer || {};
  let { store_id } = user;

  const [isReload, setIsReload] = useState(true);

  const onloadData1 = async () => {
    // associated_stores is fetched once during preload_menu_data at login —
    // no need to refetch here.
    const _storesData = props?.reducer?.associated_stores || [];

    if (!props?.cartProps?.storeOffer) {
      const offers = await store_offer();
      props.store_offers(offers);
    }
    if (!props?.customerReducer?.customerMembership || props?.customerReducer?.customerMembership?.length === 0) {
      const membership = await get_customer_membership_plan({});
      props.customer_membership(membership);
    }
    const is_multi_store_qr = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;

    if (_storesData?.length > 1 && is_multi_store_qr) {
      // Force fetch to ensure all stores are covered
      // Original:
      // await fetchAllItemsAndCategories(_storesData, is_multi_store_qr);
      const currentStoreId = props?.reducer?.appliedfilters?.selected_store?.store_id || (_storesData.length > 1 ? _storesData[1]?.store_id : _storesData[0]?.store_id);
      const isStoreLoaded = props?.reducer?.loaded_stores?.includes(String(currentStoreId));
      if (!isStoreLoaded) {
        await props.preload_menu_data();
      }

      if (!props?.reducer?.labels) {
        const label = await get_label_list();
        props.label_list(label);
      }
    } else if (props?.item) {
      if (!catalogItems || !catalogCategories || !catalogAddons) {
        // Original:
        // await fetchAllItemsAndCategories(_storesData, is_multi_store_qr);
        await props.preload_menu_data();
      }
      if (!props?.reducer?.labels) {
        const label = await get_label_list();
        props.label_list(label);
      }
    }

    if (user?.location_id?.toLowerCase() === "ta") {
      const storeOrderType = await get_order_type();
      const orderType = storeOrderType.find(
        (e) => e.order_code === "TA" || e.order_code === "ta"
      );
      if (orderType) {
        props.set_order_type({ order: orderType });
      }
    }

    setIsReload(false);
  };

  const fetchAllItemsAndCategories = async (storesData, isMultiStore) => {
    let _storesToFetch = [];
    if (isMultiStore) {
      _storesToFetch = storesData || [];
      // Ensure parent store is included
      if (!_storesToFetch.find((s) => String(s.store_id) == String(store_id))) {
        _storesToFetch.push({ store_id: store_id });
      }
    } else {
      _storesToFetch = [{ store_id: store_id }];
    }

    // Fetch addons per store + ALL items + ALL categories in one go (concurrent)
    let addonFunc = _storesToFetch.map((s) => get_addon_list({ store_id: s.store_id }));

    const [addonArr, rawDataItem, rawCatItem] = await Promise.all([
      Promise.all(addonFunc),
      get_item_list(), // single call — returns all stores' items already flattened with store_id
      get_category(),  // single call — returns all stores' categories already flattened with store_id
    ]);

    // --- Categories ---
    const catagoryData = Array.isArray(rawCatItem) ? rawCatItem : [];

    // Scheduler filter
    const timeZone = storeInfo?.store_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = new Date();
    const currentDay = new Intl.DateTimeFormat("en-US", { weekday: "long", timeZone }).format(now).toLowerCase();

    const timeParts = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      hourCycle: "h23",
      timeZone
    }).formatToParts(now);

    let hour = timeParts.find(p => p.type === "hour")?.value || "00";
    if (hour === "24") hour = "00";
    hour = hour.padStart(2, "0");
    let minute = timeParts.find(p => p.type === "minute")?.value || "00";
    minute = minute.padStart(2, "0");
    const currentTime = `${hour}:${minute}`;

    const filteredCategories = catagoryData.filter((cat) => {
      if (!cat?.scheduler || !Array.isArray(cat.scheduler) || cat.scheduler.length === 0) return true;
      return cat.scheduler.some((sched) => {
        if (sched?.status === false) return false;
        if (!sched?.day_slots || !Array.isArray(sched.day_slots)) return false;
        return sched.day_slots.some((ds) => {
          if (ds?.day?.toLowerCase() !== currentDay) return false;
          if (!ds?.slots || !Array.isArray(ds.slots)) return false;
          return ds.slots.some((slot) => {
            const start = slot?.start_time || "00:00";
            const end = slot?.end_time || "23:59";
            return currentTime >= start && currentTime <= end;
          });
        });
      });
    });

    props.item_category(filteredCategories);

    // --- Addons ---
    let rawDataAddon = [].concat(...addonArr.filter((res) => res && Array.isArray(res)));
    const uniqueAddons = [];
    const addonGroupIds = new Set();
    rawDataAddon.forEach(addon => {
      if (!addonGroupIds.has(addon.addon_group_id)) {
        addonGroupIds.add(addon.addon_group_id);
        uniqueAddons.push(addon);
      }
    });
    props.addon_list(uniqueAddons);

    // --- Items (already fetched as flat array with store_id on each item) ---
    const allItems = Array.isArray(rawDataItem) ? rawDataItem : [];
    console.log("DEBUG: total items from single API call:", allItems.length);


    // Filter items based on active scheduler slots matching store local time/day
    const dataItem = allItems.filter((item) => {
      if (!item?.scheduler || !Array.isArray(item.scheduler) || item.scheduler.length === 0) {
        return true; // Always show if no item scheduler configured
      }

      return item.scheduler.some((sched) => {
        if (sched?.status === false) return false;
        if (!sched?.day_slots || !Array.isArray(sched.day_slots)) return false;

        return sched.day_slots.some((ds) => {
          if (ds?.day?.toLowerCase() !== currentDay) return false;
          if (!ds?.slots || !Array.isArray(ds.slots)) return false;

          return ds.slots.some((slot) => {
            const start = slot?.start_time || "00:00";
            const end = slot?.end_time || "23:59";
            return currentTime >= start && currentTime <= end;
          });
        });
      });
    });

    console.log(`DEBUG: active filtered items count after scheduler filter:`, dataItem.length);

    let itemData;
    if (filter?.dietary) {
      itemData = dataItem.filter(
        (item) => item && (item.dietary === filter?.dietary || !item.dietary)
      );
    } else {
      itemData = dataItem.filter(Boolean);
    }

    let allItemVerriant = [];
    const activeChannelCode = props?.selectOrderType || orderType?.order?.order_code || "DI";

    const updatedVariants = itemData.map((item) => {
      const matchedChannelPlu = item.channel_plu?.find(
        (w) => w?.channel_code?.toLowerCase() === activeChannelCode?.toLowerCase()
      );

      const channelValue = parseFloat(matchedChannelPlu?.plu || 0);

      const updatedItemVariants = (item.item_variant || []).map((variant) => {
        const basePlu = parseFloat(variant.plu || 0);
        const updatedPlu = (basePlu + channelValue).toFixed(2);

        allItemVerriant.push({
          ...item,
          item_variant: [{ ...variant, plu: updatedPlu }],
        });

        return {
          ...variant,
          plu: updatedPlu,
        };
      });

      return {
        ...item,
        item_variant: updatedItemVariants,
      };
    });

    console.log("DEBUG: final processed items count:", updatedVariants.length);
    props.item_list(updatedVariants);
    props.item_verriant_list(allItemVerriant);
  };

  const updateItems = async (type) => {
    setNewOrderType(props?.selectOrderType);
    props.clearCart();

    const _storesData = props?.reducer?.associated_stores || [];
    const is_multi_store_qr = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;

    await fetchAllItemsAndCategories(_storesData, is_multi_store_qr);
  };

  useEffect(() => {
    if (newOrderType !== props?.selectOrderType && !props?.cartPage) {
      props.item_list([]);
      props.item_verriant_list([]);
      updateItems(Ordertype);
    }
  }, [newOrderType !== props?.selectOrderType]);

  useEffect(() => {
    if (isReload) {
      onloadData1();
    }
  }, [isReload]);

  const selectedStoreId = props.reducer?.appliedfilters?.selected_store?.store_id;
  const loadedStores = props.reducer?.loaded_stores || [];

  useEffect(() => {
    if (selectedStoreId && !loadedStores.includes(String(selectedStoreId))) {
      props.preload_menu_data();
    }
  }, [selectedStoreId, loadedStores]);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };
  return (
    <>
      {isDesktop ? (
        <Box
          sx={{
            backgroundColor: primaryColor || "#eb5c24", // Fallback color
            color: "white",
            width: "100%",
            paddingTop: "15px",
            paddingBottom: "15px",
            paddingLeft: "35px",
            paddingRight: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          {/* Logo & Store Name */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }} onClick={handleHomeClick}>
            {storeInfo?.store_display_logo && (
              <img
                src={storeInfo.store_display_logo}
                alt="Store Logo"
                style={{ height: "44px", width: "44px", minWidth: "44px", minHeight: "44px", flexShrink: 0, backgroundColor: "white", borderRadius: "7px", padding: (location.pathname === "/" || location.pathname === "/home" || location.pathname === "/aboutus") ? "0px" : "3px", objectFit: "contain" }}
              />
            )}
            <Typography sx={{ fontWeight: 700, fontSize: "22px", fontFamily: "Satoshi" }}>
              {storeInfo?.store_name || ""}
            </Typography>
          </Box>

          {/* Navigation Links */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 5 }}>
            {[
              { label: "Home", path: "/" },
              { label: "Order Now", path: "/menu" },
              { label: "About Us", path: "/aboutus" },
              { label: "Contact Us", path: "/contactus" },
            ].map((navItem) => {
              const isActive =
                (navItem.path === "/" && (location.pathname === "/" || location.pathname === "/home")) ||
                (navItem.path === "/menu" && (location.pathname === "/menu" || location.pathname === "/menu-items")) ||
                (navItem.path === "/aboutus" && (location.pathname === "/aboutus" || location.pathname === "/about-us")) ||
                (navItem.path === "/contactus" && (location.pathname === "/contactus" || location.pathname === "/contact-us"));

              return (
                <Box
                  key={navItem.label}
                  sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={(e) => navItem.path === "/" ? handleHomeClick(e) : navigate(navItem.path, { state: { skipAutoRedirect: true } })}
                >
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "17px",
                      fontFamily: "Satoshi",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    {navItem.label}
                  </Typography>
                  {isActive && (
                    <Box
                      sx={{
                        width: "100%",
                        height: "2.5px",
                        backgroundColor: "white",
                        borderRadius: "2px",
                        opacity: 1,
                        position: "absolute",
                        bottom: "-3px",
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Box>

          {/* Login / User Info & Cart OR Direct Hamburger when is_menu is true */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {menuStore ? (
              <IconButton
                onClick={handleSidebarOpen}
                style={{
                  color: "white",
                  padding: "6px",
                  borderRadius: "8px",
                  // backgroundColor: "rgba(255, 255, 255, 0.15)",
                }}
              >
                <MenuIcon style={{ color: "white", fontSize: "28px" }} />
              </IconButton>
            ) : (
              <Button
                onClick={() => {
                  if (customer !== null && customer?.cust_first_name) {
                    handleSidebarOpen();
                  } else {
                    setOpenUserInfo(true);
                  }
                }}
                style={{
                  color: "white",
                  textTransform: "none",
                  fontSize: "17px",
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "Satoshi",
                  padding: 0,
                  minWidth: "auto",
                }}
              >
                <img src={VectorIcon} alt="Vector Icon" style={{ width: "18px", height: "18px", marginRight: "9px" }} />
                <span style={{ color: "white" }}>{customer?.cust_first_name ? customer.cust_first_name : "Log In"}</span>
              </Button>
            )}
          </Box>
        </Box>
      ) : (
        <div style={{ display: "none" }}>
          <Grid
            container
            justifyContent="center"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              background:
                "linear-gradient(164deg, rgb(25, 25, 25) 0%, #2c2e30 30%, rgb(49, 51, 53) 47%, #2c2e30 65%, rgb(25, 25, 25) 100%)",
              borderBottom: `4px solid ${primaryColor || APP_BAR_COLOR}`,
              height: "58px",
            }}
          >
            {/* <img
          alt="Logo"
          style={{
            position: "absolute",
            height: "55px",
            right: "0%",
            opacity: "0.8",
          }}
          src={Bgimg}
        /> */}
            <div
              style={{
                position: "absolute",
                left: "0px",
                width: "auto",
                display: "flex",
                padding: "10px 18px ",
              }}
            >
              {!props.cart && (
                <MenuTwoToneIcon
                  style={{
                    zIndex: "1",
                    marginRight: "7px",
                    position: "relative",
                    // padding: "5px",
                    color: "white",
                    width: "10%",
                    height: "10%",
                  }}
                  onClick={handleSidebarOpen}
                />
              )}
            </div>

            <div
              style={{
                width: "auto",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                flex: "wrap",
                alignItems: "center",
              }}
              onClick={handleHomeClick}
            >
              <button style={{ padding: "0rem", zIndex: "10" }}>
                <img
                  alt="Logo"
                  width="18%"
                  height="18%"
                  style={{
                    padding: "0.5rem",
                    width: "3rem",
                    maxHeight: "3rem",
                  }}
                  src={storeInfo?.store_display_logo}
                />
              </button>
            </div>

            <div
              style={{
                position: "absolute",
                right: "0px",
                width: "auto",
                display: "flex",
                padding: "15px 18px 15px",
              }}
            >
              {/* <Link
            to="/#"
            className="module module-cart"
            data-toggle="panel-cart"
            style={{
              zIndex: "1",
              marginRight: "7px",
              position: "relative",
              padding: "5px",
              color: "white",
            }}
          >
            <ChatBubbleTwoToneIcon />
            <span
              className=" cartcount"
              style={{ top: "-8px", right: "-5px", fontSize: "12px" }}
            >
              chat
            </span>
          </Link> */}

              <Grid
                onClick={() => {
                  if (!props.cartPage) {
                    customer.cust_first_name
                      ? navigate("/cart")
                      : addedItems.length
                        ? setOpenUserInfo(true) + setSkipSignin(false)
                        : setOpenUserInfo(false);
                  }
                }}
                hidden={props.cart}
                className="module module-cart"
                data-toggle="panel-cart"
                style={{
                  zIndex: "1",
                  marginLeft: "7px",
                  position: "relative",
                  // padding: "10px",
                  color: "white",
                }}
              >


              </Grid>
            </div>
          </Grid>
        </div>
      )}
      <SignInPopup
        {...props}
        {...{
          openUserInfo,
          setOpenUserInfo,
          customer: skipSignin,
          storeInfo,
          storeInfoConfig,
        }}
      />
      <Drawer
        anchor="right"
        open={openSidebar}
        onClose={handleSidebarClose}
        PaperProps={{
          style: {
            backgroundColor: "#FAFAFA",
            borderRadius: "0px",
            width: 320,
          },
        }}
      >
        <Box
          sx={{
            width: 320,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
          role="presentation"
        >
          <div>
            {/* User Profile Header Section (Orange background) */}
            <div
              style={{
                padding: "20px 24px",
                background: primaryColor || BUTTON_COLOR || "#E8450A",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                handleSidebarClose();
                if (customer !== null && customer?.cust_first_name) {
                  navigate("/customer");
                } else if (!menuStore) {
                  setOpenUserInfo(true);
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    padding: "16px",
                  }}
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.5556 8.44444C10.5556 6.20484 11.4452 4.05696 13.0289 2.47332C14.6125 0.88968 16.7604 0 19 0C21.2396 0 23.3875 0.88968 24.9711 2.47332C26.5548 4.05696 27.4444 6.20484 27.4444 8.44444C27.4444 10.6841 26.5548 12.8319 24.9711 14.4156C23.3875 15.9992 21.2396 16.8889 19 16.8889C16.7604 16.8889 14.6125 15.9992 13.0289 14.4156C11.4452 12.8319 10.5556 10.6841 10.5556 8.44444ZM10.5556 21.1111C7.75605 21.1111 5.0712 22.2232 3.09165 24.2028C1.1121 26.1823 0 28.8672 0 31.6667C0 33.3464 0.66726 34.9573 1.85499 36.145C3.04272 37.3327 4.65363 38 6.33333 38H31.6667C33.3464 38 34.9573 37.3327 36.145 36.145C37.3327 34.9573 38 33.3464 38 31.6667C38 28.8672 36.8879 26.1823 34.9084 24.2028C32.9288 22.2232 30.244 21.1111 27.4444 21.1111H10.5556Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontSize: "17px",
                      fontFamily: "Satoshi, sans-serif",
                      color: "#ffffff",
                      lineHeight: 1.2,
                    }}
                  >
                    {customer !== null && customer?.cust_first_name
                      ? `${customer.cust_first_name} ${customer?.cust_last_name || ""}`
                      : "Guest User"}
                  </Typography>
                  <Typography
                    style={{
                      opacity: 0.9,
                      fontSize: "13px",
                      fontFamily: "Satoshi, sans-serif",
                      color: "#ffffff",
                      marginTop: "2px",
                    }}
                  >
                    Tap to manage account
                  </Typography>
                </div>
              </div>
            </div>

            {/* Main Action Cards */}
            <div style={{ padding: "20px 16px 0 16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              {/* Home Card */}
              {!isFSR && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "14px 18px",
                    borderRadius: "12px",
                    backgroundColor: "#ffffff",
                    border: "1px solid #EAEAEA",
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                  }}
                  onClick={(e) => {
                    handleSidebarClose();
                    if (props.clear_customer) {
                      props.clear_customer();
                    }
                    handleHomeClick(e);
                  }}
                >
                  <HomeIcon style={{ color: primaryColor || BUTTON_COLOR, fontSize: "22px" }} />
                  <Typography
                    style={{
                      fontWeight: "600",
                      color: "#333333",
                      fontSize: "15px",
                      fontFamily: "Satoshi, sans-serif",
                    }}
                  >
                    Home
                  </Typography>
                </div>
              )}

              {/* Recent Orders Card */}
              {!menuStore && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "14px 18px",
                    borderRadius: "12px",
                    backgroundColor: "#ffffff",
                    border: "1px solid #EAEAEA",
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                  }}
                  onClick={() => {
                    handleSidebarClose();
                    navigate("/customer");
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 19 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.3983 0.942773L16.3114 5.73696C16.3907 5.93602 16.4365 6.1164 16.469 6.32954L18.9838 21.211C19.1016 21.9089 18.5611 22.5445 17.8528 22.5406L12.5191 22.5135C12.4412 22.5142 12.3742 22.467 12.3464 22.3909C12.3182 22.3148 12.3368 22.2323 12.395 22.1781C12.682 21.9103 12.8639 21.52 12.8678 21.0866L13 6.3919L14.0496 0.978708C14.0658 0.894507 14.13 0.83391 14.2115 0.825807C14.2929 0.817352 14.3669 0.863504 14.3983 0.942773ZM7.73477 3.20458H10.4104C10.7013 3.20458 10.94 2.9548 10.94 2.6497V2.12758C10.94 1.82284 10.7013 1.5727 10.4104 1.5727H7.73477H5.05877C4.7679 1.5727 4.52921 1.82284 4.52921 2.12758V2.6497C4.52921 2.9548 4.7679 3.20458 5.05877 3.20458H7.73477ZM7.73477 0H12.835C13.0705 0 13.3096 0.207156 13.2627 0.447782L12.0996 6.3919L11.967 21.0866C11.96 21.8909 11.3391 22.5476 10.5719 22.5476H1.40122C0.633322 22.5476 -0.0732258 21.8871 0.00610221 21.0866L1.43894 6.60751L3.41967 0.447782C3.44859 0.203281 3.61182 0 3.84699 0H7.73477Z"
                      fill={primaryColor || BUTTON_COLOR || "#E8450A"}
                    />
                  </svg>
                  <Typography
                    style={{
                      fontWeight: "600",
                      color: "#333333",
                      fontSize: "15px",
                      fontFamily: "Satoshi, sans-serif",
                    }}
                  >
                    Recent Orders
                  </Typography>
                </div>
              )}
            </div>

            {/* Legal & Support Links */}
            <div
              style={{
                marginTop: "28px",
                padding: "16px 20px",
              }}
            >
              <Typography
                style={{
                  color: "#777777",
                  fontWeight: "600",
                  fontSize: "13px",
                  marginBottom: "12px",
                  fontFamily: "Satoshi, sans-serif",
                }}
              >
                Legal & Support
              </Typography>

              {[
                { text: "Privacy Policy", path: "/privacy-policy" },
                { text: "Refund Policy", path: "/refund-policy" },
                { text: "Shipping Policy", path: "/shipping-policy" },
                { text: "Terms & Conditions", path: "/terms-condition" },
                { text: "Contact Us", path: "/contactus" },
              ].map((link, index, array) => (
                <div
                  key={index}
                  style={{
                    padding: "6px 0",
                    borderBottom: index < array.length - 1 ? "1px solid #F0F0F0" : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleSidebarClose();
                    navigate(link.path);
                  }}
                >
                  <Typography
                    style={{
                      color: "#333333",
                      fontSize: "12px",
                      fontWeight: "600",
                      fontFamily: "Satoshi, sans-serif",
                    }}
                  >
                    {link.text}
                  </Typography>
                </div>
              ))}
            </div>
          </div>

          {/* Powered By Logo Footer */}
          <div
            style={{
              marginTop: "60px",
              padding: "16px 16px 24px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              backgroundColor: "#FAFAFA",
              borderTop: "1px solid #F0F0F0",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                color: "#A0AEC0",
                fontFamily: "Satoshi, sans-serif",
                fontWeight: "500",
              }}
            >
              Powered By
            </span>
            <img
              alt="Logo"
              style={{ width: "80px", height: "auto" }}
              src={CyntraLogo}
            />
          </div>
        </Box>
      </Drawer>
      <LeaveCartPopup
        open={openLeaveCartPopup}
        onClose={() => setOpenLeaveCartPopup(false)}
        onConfirm={() => {
          setOpenLeaveCartPopup(false);
          props.clearCart();
          navigate("/", { state: { skipAutoRedirect: true } });
        }}
        storeInfo={storeInfo}
        storeInfoConfig={storeInfoConfig}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer || {},
    customerReducer: state.customerReducer,
    sessionReducer: state.sessionReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    clear_customer: () => {
      dispatch(clear_customer());
    },
    item_category: (data) => {
      dispatch(item_category(data));
    },
    item_list: (data) => {
      dispatch(item_list(data));
    },
    addon_list: (data) => {
      dispatch(addon_list(data));
    },
    label_list: (data) => {
      dispatch(label_list(data));
    },
    item_verriant_list: (data) => {
      dispatch(item_verriant_list(data));
    },
    store_offers: (data) => {
      dispatch(store_offers(data));
    },
    customer_membership: (data) => {
      dispatch(customer_membership(data));
    },
    clearStateData: () => {
      dispatch(clearStateData());
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    set_order_type: (obj) => {
      dispatch(set_order_type(obj));
    },
    preload_menu_data: () => {
      dispatch(preload_menu_data());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);